import React, { FC } from 'react';
import { StyleSheet, View, Text } from 'react-native';
import CircleBar from './CircleBar';
import { GaugeCardProps } from '@components/common/CircleBar/types';

const GaugeCard: FC<GaugeCardProps> = ({ label, size, children, circleBarProps, scale, font, C, transparent, dataSet, containerStyle }) => {
  return (
    <View
      {...(dataSet ? { dataSet } : {})}
      style={[
        !transparent && {
          flex: 1,
          backgroundColor: C('Gray/Light/7'),
          borderWidth: StyleSheet.hairlineWidth,
          borderColor: C('Hairline/Light/No trans'),
          borderRadius: scale(8),
        },
        {
          padding: scale(4),
          alignItems: 'center',
        },
        containerStyle,
      ]}
    >
      <View style={{ width: size, height: size, alignItems: 'center', justifyContent: 'center' }}>
        <View style={{ position: 'absolute' }}>
          <CircleBar {...circleBarProps} size={size} />
        </View>
        {children}
      </View>
      <Text
        style={[
          font['Caption 2'],
          {
            fontSize: scale(11),
            lineHeight: scale(16),
            color: C('Label/Light/Tertiary'),
            textAlign: 'center',
            marginTop: scale(2),
          },
        ]}
        numberOfLines={1}
      >
        {label}
      </Text>
    </View>
  );
};

export default GaugeCard;
